import { render, staticRenderFns } from "./FeaturedNews.vue?vue&type=template&id=15d6592a&scoped=true&"
import script from "./FeaturedNews.vue?vue&type=script&lang=js&"
export * from "./FeaturedNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6592a",
  null
  
)

export default component.exports